import React from 'react';
import { compose, is } from 'ramda';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';

import styleFile from './ServiceHotelAvail.js';

import { checkSameProps } from '@synergycms_core/utils';
import { getSegmentsFilled, addScripts } from '../../utils';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { filterAvailServices } from '../../store/avail/availServicesActions';
import { Loading } from '@synergycms_core/components/functional/Loading';
import SearchOptions from '../../components/functional/SearchOptions';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import actions from '../../store/actions';
import { AvailServiceHeader } from '../../components/functional/AvailServiceHeader';
import { AvailServiceDetail } from '../../components/functional/AvailServiceDetail';
import { AvailServiceFooter } from '../../components/functional/AvailServiceFooter';
import { AvailMainSideSummary } from '../../components/functional/AvailMainSideSummary';
import LoyaltySummaryBanner from '../../components/functional/Loyalty/LoyaltySummaryBanner.jsx';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import LoyaltyUserPoints from '../../components/functional/Loyalty/LoyaltyUserPoints.jsx';

const { step: stepActions } = actions.customer;

const ServiceHotelAvail = class ServiceHotelAvail extends React.Component {
  static displayName = 'ServiceHotelAvail';

  services = new List();
  routerUpdating = false;

  constructor(props) {
    super(props);
    const { availServices, roomRatesSelected, hotel, referer } = this.props;
    const scripts = hotel.getIn(['extended_scripts'], undefined);
    if (scripts && scripts.size > 0 && referer) {
      addScripts(hotel, referer, 'service');
    }
    if (props.hasSelectionAvail) {
      props.resetSelectionAvail();
    }
    this.services =
      availServices &&
      availServices.get('success') === true &&
      filterAvailServices(availServices.get('services'), roomRatesSelected);

  }

  shouldComponentUpdate = (nextProps, nextState) => {
    return checkSameProps(this.props, nextProps, Object.keys(this.props));
  };

  checkRoomRates = () => {
    this.goForward = this.props.goForward.bind(this);
    this.goBack = this.props.goBack.bind(this);

    const { roomRatesSelected, segmentsFilled } = this.props;

    // Si no hi han habitacions seleccionades tirem enrere
    if (
      !roomRatesSelected ||
      !is(List, roomRatesSelected) ||
      segmentsFilled === 0 ||
      segmentsFilled !== roomRatesSelected.size
    ) {
      this.routerUpdating = true;
      this.goBack();
    }

    // Si no queden serveis per mostrar anem al formulari directament
    if (!this.routerUpdating && (!this.services || !is(List, this.services) || this.services.size === 0)) {
      this.goForward();
    }
  };

  isMobile = () => this.props.theme.uaDeviceType !== 'DESK';

  render() {
    this.checkRoomRates();
    const { classes } = this.props.theme.styles;

    return (
      !this.routerUpdating &&
      this.services && (
        <div className={classes.defaultStyle}>
          <LoyaltyUserPoints/>
          <SearchOptions innerStyle={'monoHotelSearchOptions'}/>
          <div className={classes.mainContainer}>
            <div className={[classes.serviceContainer, classes.notBaseReset].join('')}>
              {!this.isMobile() && <AvailServiceHeader onNextClick={this.props.onNextClick.bind(this)}/>}
              <ul>
                {this.services.map((service, key) => {
                  return (
                    <li key={key}>
                      <AvailServiceDetail service={service}/>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className={classes.summaryContainer}>
              <AvailMainSideSummary/>
              <LoyaltySummaryBanner/>
            </div>
            {this.props.theme.width < 901 &&
              <LoyaltySummaryBanner/>
            }
          </div>
          <AvailServiceFooter onNextClick={this.props.onNextClick.bind(this)}/>
        </div>
      )
    );
  }
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    goForward: () => {
      dispatch(stepActions.change('customerForm'));
      dispatch(actions.customer.reservation.postAsync()).then(() => {
        dispatch(actions.router.update());
      }).catch((e) => {
        if (e.name === 409) {
          dispatch(actions.avail.resetAvail());
          dispatch(actions.availServices.resetAvail());
        }
        dispatch(stepActions.change('monoHotelAvail'));
        dispatch(actions.router.update(true));
      });
    },
    goBack: () => {
      dispatch(stepActions.change('monoHotelAvail'));
      dispatch(actions.router.update());
    },
    resetSelectionAvail: () => {
      dispatch(actions.customer.params.updateParams(Map({ selection_avail: null })));
    },
    onNextClick: () => e => {
      e.preventDefault();
      dispatch(actions.events.trigger('next_step_2'));
      dispatch(actions.customer.step.next());
      dispatch(actions.customer.header.show('engine', false));
      dispatch(actions.customer.reservation.postAsync()).then(() => {
        dispatch(actions.router.update());
      }).catch((e) => {
        if (e.name === 409) {
          dispatch(actions.avail.resetAvail());
          dispatch(actions.availServices.resetAvail());
        }
        dispatch(stepActions.change('monoHotelAvail'));
        dispatch(actions.router.update(true));
      });
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const availServices = store.getIn([
    'availServices',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'string_service_query_params']),
    'response'
  ]);


  const roomRatesSelected = store.getIn(['customer', 'reservation_request', 'blocks']);
  return {
    roomRatesSelected: roomRatesSelected,
    availServices: availServices,
    segmentsFilled: roomRatesSelected ? getSegmentsFilled(roomRatesSelected) : 0,
    hasSelectionAvail: store.getIn(['customer', 'params', 'params', 'selection_avail'], null),
    hotel: store.getIn(['hotels', hotelId]),
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    referer: store.getIn(['customer', 'params', 'url_params', 'id_referer'], false),
    loyaltyUser: store.getIn(['customer', 'loyalty','user'], false)
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    onNextClick: dispatchProps.onNextClick(ownProps)
  });
};

// TODO agafar tradu d'on toca
const fragment = (
  <React.Fragment>
    <Loading
      richText={{
        ucFirst: true,
        style: ['descriptionText'],
        text: '_%estamos buscando los mejores precios para ti%_',
        translate: true
      }}
    />
  </React.Fragment>
);

export default compose(
  validateAsyncComponent(mapStateToProps, [], fragment),
  PropertyManager(['onNextClick']),
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  withThemeJSS({ styleFile, index: 200, link: true })
)(ServiceHotelAvail);
